import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty,isUndefined } from 'lodash';
import KundAutoComplete from '../KundAutoComplete'
import Spinner from "../Spinner"
import Divider from '@material-ui/core/Divider';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

export default function InputComponent(props) {
    const classes = useStyles();
    const [Kund, setKund] = React.useState(isEmpty(props.Kund)?{
        AF_kundnamn:"",
        Orgnr:"",
        Orgnr_Af:"",
        Adress:"",
        Postnr:"",
        Ort:"",
        Source:2
    }:{
        AF_kundnamn:isEmpty(props.Kund.AF_kundnamn)?props.Kund.KundNamn:props.Kund.AF_kundnamn,
        Orgnr:props.Kund.Orgnr,
        Orgnr_Af:props.Kund.Orgnr_Af,
        Adress:isEmpty(props.Kund.Adress)?isEmpty(props.Kund.MainAdress2)?props.Kund.MainAdress:props.Kund.MainAdress2:props.Kund.Adress,
        Postnr:isEmpty(props.Kund.Postnr)?isEmpty(props.Kund.MainPost2)?props.Kund.MainPost:props.Kund.MainPost2:props.Kund.Postnr,
        Ort:isEmpty(props.Kund.Ort)?isEmpty(props.Kund.MainOrt2)?props.Kund.MainOrt:props.Kund.MainOrt2:props.Kund.Ort,
        Source:props.Kund.Source,
        DefaultPricelistId:0
    });
    const [step, setStep] = React.useState(0);

    React.useEffect(() => {
        setStep(props.step)
    });
    const selectthisKund=(nkund)=>{
        console.log(nkund,"props.TypAvaffa1")
        let nku = {
            AF_kundnamn:props.KundSearch.KundNamn,
            Orgnr:props.KundSearch.Orgnr,
            Orgnr_Af:props.KundSearch.Orgnr_Af,
            Adress:props.KundSearch.adress,
            Postnr:props.KundSearch.postnr,
            Ort:props.KundSearch.ort,
            Source:props.KundSearch.Source,
            TokenA:props.KundSearch.Active,
            DefaultPricelistId:0
        }
          setKund(nku)
          props.SetAvtalKundParameters(nku)
     
    }
    React.useEffect(() => {
        let nku = {
            AF_kundnamn:props.KundSearch.KundNamn,
            Orgnr:props.KundSearch.Orgnr,
            Orgnr_Af:props.KundSearch.Orgnr_Af,
            Adress:props.KundSearch.adress,
            Postnr:props.KundSearch.postnr,
            Ort:props.KundSearch.ort,
            Source:props.KundSearch.Source,
            TokenA:props.KundSearch.Active,
            DefaultPricelistId:isUndefined(props.KundSearch.DefaultPricelistId)?0:props.KundSearch.DefaultPricelistId,
        }
        console.log(props.KundSearch,"props.TypAvaffa1")
          setKund(nku)
          props.SetAvtalKundParameters(nku)
    },[props.KundSearch]);
    return (
        <div>
            <div style={{ height: 'auto', paddingTop: '15px' }} className="row">
            <div className="col-8" style={{ height: '64px' }}>
                <KundAutoComplete
                // Kund={nOrder.Kund}
                Value={isUndefined(Kund.AF_kundnamn)?0:Kund.AF_kundnamn}
                selectthisKund={selectthisKund}
                />
            </div> 
            <div className="col-4" style={{ height: 'auto' }}>
            <TextField
            label={<IntlMessages id="appKontoModule.organisationsnummer"/>}
            fullWidth
            name="Orgnr"
            value={isUndefined(Kund.Orgnr_Af)?"":isEmpty(Kund.Orgnr_Af)?String(Kund.Orgnr).split("_")[0]:Kund.Orgnr_Af}
            size="small"
            InputProps={{readOnly: true}}
            InputLabelProps={{shrink: true}}
            variant="outlined"
            />
            </div> 
            <div style={{ paddingTop: '15px', paddingBottom: '10px' }}>
                <Divider />
            </div>
            </div>
            {/*
            <div className={`text-center ${step===3 ? "d-none" : ""}`} style={{ height: '64px', paddingTop: '28px' }}>
                <BussinesIcon color="primary" fontSize="large"/>
            </div>
            <form className={classes.root}>
                <div>
                    <div>
                       <KundAutoComplete
                        Value={isUndefined(Kund.AF_kundnamn)?0:Kund.AF_kundnamn}
                        selectthisKund={selectthisKund}
                        /> 
                       
                    </div>
                </div>  
                {  
        <>
                <div className="row" style={{ height: '64px', paddingTop: '15px' }}>
                <div className="col-6">
                        <TextField
                            label={<IntlMessages id="Customer.Name"/>}
                            value={Kund.AF_kundnamn}
                            fullWidth
                            size="small"
                            name="AF_kundnamn"
                            margin="normal"
                            onChange={(e)=>handleChange(e)}
                            InputLabelProps={{
                                shrink: true
                            }}
                            variant="outlined"
                        />
                    </div>
                   
              
                    <div className="col-6">
                        <TextField
                            label={<IntlMessages id="appKontoModule.organisationsnummer"/>}
                            fullWidth
                            name="Orgnr"                             
                            onChange={(e)=>handleChange(e)}
                            value={Kund.Orgnr}
                            size="small"
                            margin="normal"
                            InputProps={{
                                readOnly: (Kund.Source===1)?true:false,
                              }}
                            InputLabelProps={{
                                shrink: true
                            }}
                            variant="outlined"
                        />
                    </div>
                </div>
                <div className="row" style={{ height: '64px', paddingTop: '15px' }}>
                <div className="col-12">
                        <TextField
                            label={<IntlMessages id="input.Address"/>}
                            value={Kund.Adress}
                            fullWidth
                            name="Adress"
                            size="small"
                            onChange={(e)=>handleChange(e)}
                            margin="normal"
                            InputLabelProps={{
                                shrink: true
                            }}
                            variant="outlined"
                        />
                    </div>
                    </div>
                <div className="row" style={{ height: '64px', paddingTop: '15px' }}>
              
                    <div className="col-6">
                        <TextField
                            label={<IntlMessages id="input.ZipCode"/>}
                            fullWidth
                            name="Postnr"
                            value={Kund.Postnr}
                            size="small"
                            onChange={(e)=>handleChange(e)}
                            margin="normal"
                            InputLabelProps={{
                                shrink: true
                            }}
                            variant="outlined"
                        />
                    </div>
                    <div className="col-6">
                        <TextField
                            label={<IntlMessages id="input.City"/>}
                            fullWidth
                            name="Ort"
                            value={Kund.Ort}
                            size="small"
                            onChange={(e)=>handleChange(e)}
                            margin="normal"
                            InputLabelProps={{
                                shrink: true
                            }}
                            variant="outlined"
                        />
                    </div>
                </div>
                </>
        } 
            </form>*/}
        </div>
    );
}